/**
 * The `outside=1` flag the escaped address carries.
 *
 * The join route takes the flag out of the address as soon as it has read it, but the
 * environment is read later than that, so the answer is remembered here instead of
 * being looked for in an address that no longer has it.
 *
 * The answer belongs to the page that was escaped to, and this is a single-page app:
 * it is held against that page's path and dropped as soon as the person navigates
 * somewhere else, so a later meeting in the same tab is not read as an escape.
 */

const OUTSIDE_PATTERN = /[?&]outside=1(&|$)/;

/** The path the escape landed on, or `null` when this page was opened normally. */
let escapedPath: string | null = null;

/** Called by the join route while the flag is still in the address. */
export function rememberOutsideEscape(): void {
	escapedPath = window.location.pathname;
}

/** The search string as the page was opened, flag included, whatever the address says now. */
export function searchAsOpened(liveSearch: string): string {
	if (escapedPath === null) return liveSearch;
	// Navigated away from the escaped page, so the escape is over.
	if (escapedPath !== window.location.pathname) {
		escapedPath = null;
		return liveSearch;
	}
	if (OUTSIDE_PATTERN.test(liveSearch)) return liveSearch;
	const separator = liveSearch.startsWith('?') ? '&' : '?';
	return `${liveSearch}${separator}outside=1`;
}
